import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=3ced9006&scoped=true&"
import script from "./RuleModal.vue?vue&type=script&lang=js&"
export * from "./RuleModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=3ced9006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced9006",
  null
  
)

export default component.exports